import {Component, Prop, Vue} from 'vue-facing-decorator';

@Component({})
export default class FormError extends Vue {

    @Prop({type: Array, default: null})
    public readonly errors: string[];

}
